export default "__VITE_ASSET__6531519a__"